<template>
<div id="flash">
  <div class="alert alert-danger" role="alert" v-if="errors">
    <h4>
      The following error<span v-if="errors.length > 1">s</span> occurred:
    </h4>
    <p v-for="error in errors">
      {{ error }}
    </p>
  </div>
  <div class="alert alert-success text-center" role="alert" v-if="result">
    {{ result }}
  </div>
</div>
</template>

<script>
import FlashStore from '@/stores/FlashStore'

export default {
  name: 'flash',

  data () {
    return FlashStore.state
  },

  computed: {
    flashSuccessEle () {
      return document.querySelector('#flash .alert-success')
    }
  },

  methods: {
    clear () {
      FlashStore.clear()
    },

    setErrors (errors) {
      FlashStore.clear()
      FlashStore.errors(errors)
    },

    setResult (result) {
      FlashStore.clear()
      FlashStore.result(result)
    }
  }
}
</script>

<style scoped>
  .results {
    color: green;
  }

  .errors {
    color: red;
  }

  p {
    margin-bottom: 0
  }
</style>



// WEBPACK FOOTER //
// src/components/Flash.vue